<template>
    <div>
      <div class="title">蹲蹲维保隐私政策</div>
      <div class="content">
        <div class="bold">维保APP隐私保护指引</div>
        <p>版本更新提示：</p>
        <p>更新日期：2024年07月09日</p>
        <p>生效日期：2024年07月11日</p>
        <p>阅读提示</p>
        <p>导言</p>
        <p>1. 个人信息的收集和使用</p>
        <p>2. Cookie等同类技术的使用</p>
        <p>3. 信息的存储</p>
        <p>4. 信息安全</p>
        <p>5. 信息共享</p>
        <p>6. 您的权利</p>
        <p>7. 联系我们</p>
        <p>附录：定义</p>
        <div class="bold">阅读提示</div>
        <p>
          (1)
          请您在使用/继续使用维保APP的产品和/或服务前仔细阅读、充分理解《维保APP隐私保护指引》完整版全文，并在同意全部内容后使用/继续使用。除非另有说明，不同意《维保APP隐私保护指引》或其更新（我们将及时通知您此类更新）可能会影响您正常使用或继续正常使用我们的产品和/或服务。
        </p>
        <p>
          (2)
          为便于您快速了解《维保APP隐私保护指引》内容，我们将通过《维保APP隐私政策摘要》向您简单、直观地说明我们是如何处理和保护您的个人信息，更多有关我们对您的个人信息的处理规则，请查阅完整版《维保APP隐私保护指引》。
        </p>
        <div class="bold">导言</div>
        <p>
          (1)维保APP是由 <b>中云汇(成都)物联科技有限公司</b> （以下简称为“我们”）提供服务的专供本公司内部或者合作伙伴公司员工和维护保洁员工使用的工业软件，我们的注册地为
          成都市武侯区双丰路53号3楼305室。如果您对本指引或相关问题有任何疑问或顾虑，请通过本指引“联系我们”中所提供的联系方式与我们联系。
        </p>
        <p>
          (2)本隐私保护指引适用于我们通过维保APP对外提供的各项保障服务。如某一客户端或某一应用软件版本有特殊功能或特殊个人信息处理活动的，我们会予以说明。如我们的客户端、产品和/或服务单独设置了隐私政策/隐私协议的，单独的隐私政策/隐私协议优先于本隐私保护指引适用；单独的隐私政策/隐私协议未提及的内容，适用本隐私保护指引。
        </p>
        <p>
          (3)针对涉及与您的权益（可能）存在重大关系的条款以及涉及敏感个人信息（定义见附录）的处理，我们在本指引中将采用粗体、下划线或其他合理方式提示您重点阅读。
        </p>
        <p>
          (4)您同意本指引表示您已经了解并同意在相关场景下，为实现功能运行，我们将对您的相关个人信息进行处理。但这并不代表只要您开始使用我们的产品与/或服务，我们将处理本指引中涉及的全部个人信息。仅当您使用特定功能时，我们才会根据“最小必要”原则，为实现向您提供服务的目的，处理您的相关个人信息。
        </p>
        <p>
          (5)除本指引外，在特定场景下，我们将以及时告知的方式（包括但不限于更新本指引、重新签署文件、页面提示、弹窗、网站公告或其他便于您获知的方式）另行向您详细说明对应信息的处理目的、方式、范围等规则，并在征得您的授权同意后处理。
        </p>
  
        <div class="bold">本隐私保护指引将帮助您了解以下内容：</div>
        <p>1.个人信息的收集和使用</p>
        <p>2.Cookie等同类技术的使用</p>
        <p>3.信息的存储</p>
        <p>4.信息安全</p>
        <p>5.信息共享</p>
        <p>6.您的权利</p>
        <p>7.联系我们</p>
        <div class="con bold">我们收集使用的信息</div>
        <p>我们共享的信息</p>
        <div class="bold">1. 个人信息的收集和使用</div>
        <p>
          为帮您快速了解我们关于您的个人信息收集、使用的主要情况，我们以专项列出的形式进行了逐条说明。
        </p>
        <p>
          【原则与途径】我们会遵循合法、正当、最小必要、公开透明的原则，收集和使用您在使用我们的产品和/或服务过程中主动提供或因使用我们的产品和/或服务而产生的个人信息。
        </p>
        <p class="bold">【系统权限】获取相机、位置信息、麦克风系统权限。</p>
        <p class="bold">1.相机相册权限</p>
        <p>
          为方便维护人员日常运维工作中，及时拍摄上传设备相关信息，我们需要向您申请相机权限，以便更好的拍摄拍照，获取设备运行情况。
        </p>
        <p class="bold">2.位置权限</p>
        <p>
          为方便维护人员日常运维工作中上班打卡，
          我们需要向您申请位置权限，以便更准确的满足打开上班条件；为方便巡检人员就近选择附近设备，需要获取位置信息，以匹配一定距离内相应的设备。
          请您放心，我们申请访问的权限只限于实现特定的功能所必需，以保障日常维保工作能正常开展。如您拒绝或撤回授权系统权限，会使您无法使用相应功能或者影响工作正常开展。
        </p>
        <p class="bold">
          3.麦克风权限
        </p>
        <p>
          为了优化您的体验感受，我们新增了AI语音助手功能，我们需要向您申请麦克风使用权限，以便您能与AI助手进行语音对话，如果您拒绝或撤回授权权限，将无法使用AI助手的语音对话功能。
        </p>
  
        <p>
          【业务功能】我们收集的您的个人信息类型仅限于公司内部维护员工更好履行工作责任，做好日常运维相关工作。如果某一需要收集您的个人信息的功能或场景未能在本指引中予以说明的，或者我们超出了与收集您的个人信息时所声称的目的及具有直接或合理关联范围的，我们会再次向您告知，并根据法律法规的相关要求征得您的同意。
        </p>
        <p>通常情况下，我们会在以下场景中收集您的个人信息：</p>
        <p>1.1 账号生成</p>
        <p>
          公司内部会为相应员工生成专属账号和密码，并将账号和密码口头、短信或邮件通知到员工，
          此账号产生的过程不需要员工自己注册。
          您可以在维保APP内补充个人资料，您可自主选择填写您的头像、昵称，邮箱，性别，身份证等，还可以修改您的密码以方便记忆。
        </p>
        <p>1.2 获取显示用户姓名</p>
        <p>
          为方便内部员工管理，生成账号的时候会使用员工 <b>真实姓名</b>，此真实姓名只限于在维保APP内使用，不会导致信息泄露等风险。具体请参照第4项信息安全说明。
        </p>
        <p>1.3 账号资料维护</p>
        <p>
          您可以在维保APP内补充个人资料，您可自主选择填写您的 <b>头像、昵称，邮箱，性别，身份证</b> 等，还可以修改您的密码以方便记忆。您在上传/更换头像时，我们会请求您的 <b>相机、相册权限</b> ，并在经您授权后收集您 <b>上传/更换的图片信息</b> 。
        </p>
        <p>1.4 选择区域设备</p>
        <p>
          当维保人员开展巡检工作，就近挑选一定距离的设备的时候，需要请求和获取您的 <b>位置权限</b> ，以便更准确的开展设备巡检工作。
        </p>
        <p>1.5 工单信息上传或发布</p>
        <p>
          当您发起/处理工单需要上传照片等功能时，我们将收集您 <b>上传的图文/音频内容 、发布的信息内容、维保APP账号ID</b>等相关内容。在您使用前述工单处理功能时，我们可能会请求您授权 <b>相机权限、相册权限</b> 。
        </p>
        <p>1.6 AI助手语音聊天</p>
        <p>您可以在App中与智能AI助手语音聊天，获取企业介绍、公司发展历程、产品咨询相关、各个驿站信息等</p>
        <div class="bold">2. Cookie等同类技术的使用</div>
        <p>
          Cookie及同类技术是互联网中普遍使用的技术。当您使用我们的产品和/或服务时，我们可能会使用Cookie及同类技术收集您的登录信息，用于确保我们平台的正常运转、简化您重复操作的步骤（如登录）、向您提供更切合您个人需要或您更感兴趣的服务内容、保护您的信息和账号安全性、提升我们的产品和服务等。
        </p>
        <p>
          我们不会将 Cookie 及同类技术用于本隐私保护指引所述目的之外的任何用途。
        </p>
        <div class="bold">3. 信息的存储</div>
        <p>3.1 存储地点</p>
        <p>
          我们在中华人民共和国境内运营中收集和产生的个人信息存储于中华人民共和国境内。目前我们暂时不存在向境外提供您的个人信息的场景。
        </p>
        <p>
          如我们因业务等需要，确需向中华人民共和国境外提供个人信息的，我们应具备法律规定的条件（通过国家网信部门组织的安全评估或按照国家网信部门制定的标准合同与境外接收方订立合同，约定双方的权利和义务等），并将向您告知境外接收方的名称或者姓名、联系方式、处理目的、处理方式、个人信息的种类以及您向境外接收方行使个人信息主体权利的方式和程序等事项，取得您的单独同意。我们将采取必要措施，保障境外接收方处理个人信息的活动达到中国法律规定的个人信息保护标准。
        </p>
        <p>3.2 存储期限</p>
        <p>
          我们将在实现您的个人信息处理目的所必要的最短时间内保存您的个人信息，但您行使删除权、注销账号或法律法规另有规定的除外（例如：《电子商务法》规定：商品和服务信息、交易信息保存时间自交易完成之日起不少于三年）。超出上述存储期限后，我们会对您的个人信息进行删除或匿名化处理。
        </p>
        <p>
          当我们的产品或服务停止运营时，我们将以推送通知、公告等形式通知您，并在合理期限内删除您的个人信息或进行匿名化处理，法律法规另有规定的除外。
        </p>
        <div class="bold">4. 信息安全</div>
        <p>4.1 安全保护措施</p>
        <p>
          我们努力为您的个人信息安全提供保障，以防止个人信息的泄露、篡改、丢失、不当使用、未经授权的访问和披露等。我们采用多方位的安全保护措施，包括技术保护措施、管理制度控制、安全体系保障等方面，以确保您的个人信息保护处于合理的安全水平。
        </p>
        <p>(1)技术保护措施</p>
        <p>
          我们采用业界领先的技术保护措施保护您的个人信息，包括但不限于防火墙、加密（例如SSL）、去标识化或匿名化处理、访问控制措施等。此外，我们还会不断加强安装在您设备端的软件的安全能力。例如，我们会在您的设备本地完成部分信息加密工作，以巩固安全传输；我们会了解您设备安装的应用信息和运行的进程信息，以预防病毒、木马等恶意程序。
        </p>
        <p>(2)管理制度和操作规程</p>
        <p>
          我们建立了保障个人信息安全的内部管理制度和操作规程。对个人信息实行分类管理，合理确定个人信息处理的操作权限，并定期对从业人员进行安全教育和培训。
        </p>
        <p>4.2 安全事件处置措施</p>
        <p>
          若发生或可能发生个人信息泄露、篡改、丢失等个人信息安全事件，我们会启动个人信息安全事件应急预案，阻止个人信息安全事件扩大。
          个人信息安全事件发生后，除非我们采取措施能够有效避免信息泄露、篡改、丢失造成危害的，我们将及时以推送通知、邮件等形式告知您个人信息安全事件的基本情况、我们即将或已经采取的处置措施和补救措施，以及我们对您的应对建议。如果难以实现逐一告知，我们将通过公告等方式发布警示。
        </p>
        <div class="bold">5. 信息共享</div>
        <p>5.1 个人信息转移</p>
        <p>我们不会将您的个人信息转移给任何公司、组织和个人，但以下情形除外：</p>
        <p>(1)在获得您的明确同意后，我们会向其他方转移您的个人信息；</p>
        <p>
          (2)因合并、分立、解散、被宣告破产等原因需要转移您的个人信息的，我们将向您告知接收方的名称或者姓名和联系方式，并会要求新的持有您个人信息的公司、组织继续受此政策的约束，否则我们将要求该公司、组织重新向您征求同意。
        </p>
        <p>5.2 公开披露</p>
        <p>
          我们不会对外公开披露所收集的个人信息，如必须公开披露时，我们会向您告知此次公开披露的目的、披露信息的类型及可能涉及的敏感信息，并征得您的单独同意。
        </p>
        <div class="bold">6. 您的权利</div>
        <p>6.1注销账号</p>
        <p>
          处于员工离职等其他原因需要注销账户的，可以联系我们的客服协助您进行注销。注销成功后，我们将停止为您提供维保APP的全部产品和/或服务，我们将根据法律法规的要求尽快删除您的个人信息或作匿名化处理。
        </p>
        <p>
          6.2 获取本隐私保护指引的解释说明
          您可以通过本隐私保护指引第7节提供的方式联系我们，要求我们对本隐私保护指引进行解释说明。
        </p>
        <div class="bold">7. 联系我们</div>
        <p>
          我们设立了专门的个人信息保护团队和个人信息保护负责人，如果您对本隐私保护指引或个人信息保护相关事宜有任何疑问或投诉、建议时，您可以通过以下方式与我们联系：
        </p>
        <p>(1) 您可以填写个人信息保护和隐私问题反馈问卷与我们联系；</p>
        <p>(2) 通过www.dundd.cn与我们联系；</p>
        <p>(3) 将您的问题邮寄至下列地址：</p>
        <p>成都市武侯区双丰路53号2楼201 数据隐私保护部（收）</p>
        <p>邮编：610000</p>
        <p>我们将尽快审核所涉问题，并在15日或法律法规规定的期限内予以反馈。</p>
        <div class="bold">中云汇(成都)物联科技有限公司</div>
        <div class="bold">附录：定义</div>
        <p>
          个人信息：指以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息（出自《中华人民共和国个人信息保护法》第四条）。
        </p>
        <p>
          敏感个人信息：一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息，包括生物识别、宗教信仰、特定身份、医疗健康、金融账户、行踪轨迹等信息，以及不满十四周岁未成年人的个人信息（出自《中华人民共和国个人信息保护法》第二十八条）。
        </p>
        <p>
          匿名化：是指个人信息经过处理无法识别特定自然人且不能复原的过程（出自《中华人民共和国个人信息保护法》第七十三条）.
        </p>
        <p>
          去标识化：是指个人信息经过处理，使其在不借助额外信息的情况下无法识别特定自然人的过程（出自《中华人民共和国个人信息保护法》第七十三条）.
          处理个人信息：指个人信息的收集、存储、使用、加工、传输、提供、公开、删除等。
        </p>
        <p>
          Cookie：Cookie是包含字符串的小文件，在您登入和使用网站或其他网络内容时发送、存放在您的计算机、移动设备或其他装置内（通常经过加密）。
        </p>
        <p>
          Cookie同类技术是可用于与Cookie类似用途的其他技术，例如：Web
          Beacon、Proxy、嵌入式脚本、像素标签等。
        </p>
        <p>
          SSL：SSL（Secure Socket
          Layer）又称为安全套接层，是在传输通信协议（TCP/IP）上实现的一种安全协议。SSL支持各种类型的网络，同时提供三种基本的安全服务，均通过使用公开密钥和对称密钥技术以达到信息保密的效果。
        </p>
      </div>
      <div class="bottom">
        <img src="../assets/guohui.png" alt="">
        <span>蜀ICP备2021009379号-4A</span>
      </div>
    </div>
  </template>
  
  <script>
  // @ is an alias to /src
  
  export default {
    components: {},
  };
  </script>
  <style scoped>
  div {
    font-size: 14px;
    padding: 10px 10px 0;
  }
  .bold {
    font-weight: 700;
  }
  
  .title {
    font-size: 18px;
    text-align: center;
    font-weight: 700;
  }
  .con {
    text-align: center;
  }
  
  .content p {
    text-indent: 1em;
    margin: 5px 0;
  }
  .bottom {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .bottom img{
    width:20px;
  }
  </style>
  